import React from "react";

import { Action } from "constants/events";
import { ProductCategory } from "custom-types/Brand";
import { useEventTracker } from "hooks/useEventTracker";

import ProductCategoryCard from "components/botanic/ProductCategoryCard";

import { BRAND_CATEGORY_IMAGE_MAP } from "./brandProductCategoryImages";

const BrandProductCoins = ({
  sortedCategories,
  brandSlug,
  brandId,
  featureTier,
}: {
  sortedCategories: ProductCategory[];
  brandSlug: string;
  brandId: number;
  featureTier?: string;
}) => {
  const { publishEvent } = useEventTracker();

  if (!sortedCategories || sortedCategories.length === 0) {
    return null;
  }

  return (
    <div>
      <h2 className="heading--m font-extrabold">Shop by category</h2>
      <div className="-mx-lg p-sm pb-md overflow-x-scroll">
        <ul
          data-testid="coin-list"
          className="inline-flex lg:flex -mr-sm lg:mr-none"
        >
          {sortedCategories.map((category) => {
            return (
              <li
                key={category.name}
                className="mx-sm flex-shrink-0"
                style={{ minWidth: 80, width: 80 }}
              >
                <ProductCategoryCard
                  image={BRAND_CATEGORY_IMAGE_MAP[category.name]}
                  title={category.name}
                  titleSize="xs"
                  titleClassName="underline"
                  url={`/brands/${brandSlug}/catalog/${category.slug}`}
                  disableLazyLoad={true}
                  sizes={[80]}
                  onClick={() => {
                    publishEvent({
                      action: Action.click,
                      brandId: brandId,
                      category: `brand ${featureTier}`,
                      label: `products category coin - ${category.name.toLowerCase()}`,
                    });
                  }}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default BrandProductCoins;
